import { useEffect, useState } from "react";
import { useApi } from "../lib/api";
import { TAG_STATUS, ORDER_STATUS } from "../lib/constants";

export const Pill = ({ map, value, testid }) => {
  const s = map[value] || { label: value, cls: "bg-slate-700 text-slate-200" };
  return <span data-testid={testid} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${s.cls}`}>{s.label}</span>;
};
export const TagStatus = ({ value, testid }) => <Pill map={TAG_STATUS} value={value} testid={testid} />;
export const OrderStatus = ({ value, testid }) => <Pill map={ORDER_STATUS} value={value} testid={testid} />;

export const PageHeader = ({ overline, title, children }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 fade-up">
    <div>
      {overline && <div className="overline mb-2">{overline}</div>}
      <h1 className="text-3xl sm:text-4xl font-black tracking-tight">{title}</h1>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Stat = ({ label, value, hint, testid }) => (
  <div className="panel p-5 lift" data-testid={testid}>
    <div className="overline">{label}</div>
    <div className="font-display text-3xl font-black mt-2">{value}</div>
    {hint && <div className="text-xs text-slate-400 mt-1">{hint}</div>}
  </div>
);

export const Completeness = ({ value }) => (
  <div className="flex items-center gap-2 min-w-[110px]" data-testid="completeness-indicator">
    <div className="h-1.5 flex-1 rounded bg-slate-700 overflow-hidden">
      <div className="h-full rounded" style={{ width: `${value || 0}%`, background: "var(--group)" }} />
    </div>
    <span className="text-xs font-mono text-slate-300 w-9 text-right">{value || 0}%</span>
  </div>
);

export const Empty = ({ children, testid }) => (
  <div data-testid={testid} className="border border-dashed border-slate-700 rounded-lg p-10 text-center text-slate-400 text-sm">{children}</div>
);

export function AuthImg({ path, className, alt = "" }) {
  const api = useApi();
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api.get(path, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => setSrc(null));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [api, path]);
  if (!src) return <div className={`${className} bg-slate-800`} />;
  return <img src={src} alt={alt} className={className} />;
}
